module.exports = __webpack_public_path__ + "img/17.ff8911b2.jpg";